module.exports = __webpack_public_path__ + "img/ss.b2f814f1.png";